/**
 * ReportSummary Component
 *
 * Displays total remittance payments and total Bs amount.
 * Shared across cashier, analyst, and correspondentAdmin features.
 */
import { Stack, Typography } from '@mui/material';
import { RemittanceReportResponse } from '@shared/types/remittance';

interface ReportSummaryProps {
  result: RemittanceReportResponse;
}

export const ReportSummary = ({ result }: ReportSummaryProps) => {
  return (
    <Stack direction={'column'} sx={{ minWidth: '231px' }} gap={'1px'}>
      <Stack
        direction={'row'}
        justifyContent={'space-between'}
        sx={{
          backgroundColor: '#047AE8',
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px',
          paddingInline: '14px',
          paddingBlock: '6px',
        }}>
        <Typography variant="body2" color="white">
          Total Giros
        </Typography>
        <Typography variant="body2" color="white">
          {result?.data?.total_payments}
        </Typography>
      </Stack>
      <Stack
        direction={'row'}
        justifyContent={'space-between'}
        sx={{
          backgroundColor: '#047AE8',
          borderBottomLeftRadius: '8px',
          borderBottomRightRadius: '8px',
          paddingInline: '14px',
          paddingBlock: '6px',
        }}>
        <Typography variant="body2" color="white">
          Monto total Bs
        </Typography>
        <Typography variant="body2" color="white">
          {result?.data?.total_bs}
        </Typography>
      </Stack>
    </Stack>
  );
};
